import { cn } from "@deputy-ai/common";
import "lightgallery/css/lg-thumbnail.css";
// import "lightgallery/css/lg-zoom.css"
import "lightgallery/css/lightgallery.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
// import lgZoom from "lightgallery/plugins/zoom"
import LightGallery, { type LightGalleryProps } from "lightgallery/react";

export interface ImageViewerProps {
  className?: string;
  children?: React.ReactNode;
  lightGalleryProps?: LightGalleryProps;
}

/**
 *
 * @example
 * ```tsx
 * <ImageViewer>
 *   <a href="img/img1.jpg">
 *     <img alt="img1" src="img/thumb1.jpg" />
 *   </a>
 *   <a href="img/img2.jpg">
 *     <img alt="img2" src="img/thumb2.jpg" />
 *   </a>
 * </ImageViewer>
 * ```
 *
 * @see https://www.lightgalleryjs.com/docs/react/#installation
 * @param props
 * @returns
 */
export function ImageViewer(props: ImageViewerProps) {
  const { className, children, lightGalleryProps } = props;

  const { elementClassNames, ...restLightGalleryProps } =
    lightGalleryProps ?? {};

  return (
    <LightGallery
      licenseKey="1F9FF6A9-1086-462B-B958-3A1D35F6B67B"
      elementClassNames={cn(className, elementClassNames)}
      plugins={[lgThumbnail]}
      {...restLightGalleryProps}
    >
      {children}
    </LightGallery>
  );
}
